import logo from '../assets/factspan-logo.svg'

export function Brand({ compact = false }: { compact?: boolean }) {
  return (
    <div className={`brand ${compact ? 'brand--compact' : ''}`}>
      <img src={logo} alt="Factspan" className="brand__mark" />
      {!compact && (
        <div>
          <span className="brand__company">FACTSPAN</span>
          <span className="brand__product">Knowledge Platform</span>
        </div>
      )}
    </div>
  )
}
